import { __assign } from 'tslib';
import * as React from 'react';
import { classNames } from 'uitk-react-utils';
import { isSmallKey } from './functions.esm.js';
import styles from './uitk-layout-grid.css';

var getClassNameList = classNames.bind(styles);
var UitkLayoutGridItem = function (props) {
    var _a;
    var alignSelf = props.alignSelf, area = props.area, className = props.className, colEnd = props.colEnd, colSpan = props.colSpan, colStart = props.colStart, dataTestId = props.dataTestId, justifySelf = props.justifySelf, rowSpan = props.rowSpan, rowStart = props.rowStart, rowEnd = props.rowEnd, style = props.style;
    var childrenArray = React.Children.toArray(props.children);
    if (!childrenArray.length) {
        return null;
    }
    var firstChild = childrenArray[0];
    var firstChildClassName = firstChild.props.className;
    var firstChildStyle = firstChild.props.style;
    var baseClass = 'uitk-layout-grid-item';
    var itemCustomPropValue = function (suffix, value, isSpan) {
        var _a, _b, _c;
        var isEnd = value === 'end';
        var isAll = value === 'all';
        var returnValue = {};
        if (isEnd) {
            returnValue = (_a = {},
                _a["--uitk-layoutgrid-".concat(suffix)] = "-1",
                _a);
        }
        else if (isAll) {
            returnValue = (_b = {},
                _b["--uitk-layoutgrid-".concat(suffix)] = "1",
                _b["--uitk-layoutgrid-".concat(suffix.replace('start', 'end'))] = "-1",
                _b);
        }
        else {
            returnValue = (_c = {},
                _c["--uitk-layoutgrid-".concat(suffix)] = isSpan ? "span ".concat(value) : "".concat(value),
                _c);
        }
        return returnValue;
    };
    var MakeCustomProp = function (suffix, value, isSpan) {
        var isObject = !Array.isArray(value) && typeof value === 'object';
        var obj = {};
        if (isObject) {
            Object.entries(value).map(function (_a) {
                var key = _a[0], val = _a[1];
                return Object.assign(obj, itemCustomPropValue("".concat(suffix).concat(isSmallKey(key) ? '' : "-".concat(key)), val, isSpan));
            });
        }
        else {
            Object.assign(obj, itemCustomPropValue(suffix, value, isSpan));
        }
        return obj;
    };
    /**
     * Prevent invalid CSS Custom Properties from being applied
     *
     * @param value {UitkLayoutGridItemSpanValues | UitkLayoutConditionalGridSpan | UitkLayoutGridItemStartEndValues | UitkLayoutConditionalGridStartEnd}
     * @param suffix {string}
     * @param baseCSSClass {string}
     * @returns getClassNameList()
     */
    var conditionalGridItemClassName = function (value, suffix, baseCSSClass) {
        if (baseCSSClass === void 0) { baseCSSClass = baseClass; }
        var isObject = !Array.isArray(value) && typeof value === 'object';
        return getClassNameList(isObject
            ? Object.entries(value).map(function (_a) {
                var key = _a[0];
                return "".concat(baseCSSClass, "-has-").concat(suffix).concat(isSmallKey(key) ? '' : "-by-".concat(key));
            })
            : "".concat(baseCSSClass, "-has-").concat(suffix));
    };
    var wrapperClassNames = getClassNameList(baseClass, firstChildClassName, alignSelf && "".concat(baseClass, "-align-self-").concat(alignSelf), area &&
        "".concat(baseClass, "-has-column-start ").concat(baseClass, "-has-column-end ").concat(baseClass, "-has-row-start ").concat(baseClass, "-has-row-end"), colStart && conditionalGridItemClassName(colStart, 'column-start'), colEnd && conditionalGridItemClassName(colEnd, 'column-end'), colSpan && conditionalGridItemClassName(colSpan, 'column-start'), colSpan && colSpan === 'all' && conditionalGridItemClassName(colSpan, 'column-end'), rowStart && conditionalGridItemClassName(rowStart, 'row-start'), rowEnd && conditionalGridItemClassName(rowEnd, 'row-end'), rowSpan && conditionalGridItemClassName(rowSpan, 'row-start'), rowSpan && rowSpan === 'all' && conditionalGridItemClassName(rowSpan, 'row-end'), justifySelf && "".concat(baseClass, "-justify-self-").concat(justifySelf), className);
    var gridItemCustomProps = __assign(__assign(__assign(__assign({}, (area && (_a = {},
        _a["--uitk-layoutgrid-column-start"] = "".concat(area, "-start"),
        _a["--uitk-layoutgrid-column-end"] = "".concat(area, "-end"),
        _a["--uitk-layoutgrid-row-start"] = "".concat(area, "-start"),
        _a["--uitk-layoutgrid-row-end"] = "".concat(area, "-end"),
        _a))), (!area && __assign(__assign(__assign(__assign(__assign(__assign({}, (colSpan && MakeCustomProp('column-start', colSpan, true))), (colStart && MakeCustomProp('column-start', colStart))), (colEnd && MakeCustomProp('column-end', colEnd))), (rowSpan && MakeCustomProp('row-start', rowSpan, true))), (rowStart && MakeCustomProp('row-start', rowStart))), (rowEnd && MakeCustomProp('row-end', rowEnd))))), (firstChildStyle && firstChildStyle)), (style && style));
    var decoratedChild = React.cloneElement(firstChild, __assign({ className: wrapperClassNames, style: gridItemCustomProps }, (dataTestId && { 'data-stid': dataTestId })));
    return decoratedChild;
};
UitkLayoutGridItem.displayName = 'UitkLayoutGridItem';

export { UitkLayoutGridItem };
